import React, { useEffect, useRef, useState } from "react";
import { getDOY, _common } from "../../common";
import { ServerInterface } from "../../ServerInterface";
import DayHeader from "./DayHeader";
import OneRect from "./OneRect";

const common = _common;

function Hours(props: { style: any; showHourBar: boolean }) {
  const { style, showHourBar } = props;
  const hours: any = [];

  var hh = new Date().getHours() - 0.5 + new Date().getMinutes() / 60 - common.firstHourOfDay + 2;
  hh *= common.heightHour;

  const bgHourStyle: any = {
    position: "absolute",
    left: "0px",
    top: "0px",
    height: `${hh}px`,
    borderBottom: "5px solid red",
    backgroundColor: "#8888",
    width: "100%",
    zIndex: "-1",
  };

  for (var h = common.firstHourOfDay - 1; h <= common.lastHourOfDay; h++) {
    hours.push(
      <div
        key={`H-${h}`}
        style={{
          height: common.heightHour,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {h > common.firstHourOfDay && h < common.lastHourOfDay ? h : ""}
      </div>
    );
  }
  return (
    <div
      id="hours"
      style={{
        ...props.style,
        position: "absolute",
        width: common.widthHour,
        display: "flex",
        flexDirection: "column",
        top: -common.heightHour * 1.5,
      }}
    >
      {/* <div style={{ position: "absolute", height: "500px", left: "0", top: "-500px", width: common.widthHour, backgroundColor: "red" }}>&nbsp;</div> */}

      {showHourBar && <div key="bTgime" style={bgHourStyle}></div>}

      {hours}
    </div>
  );
}
export default function Day(props: { date: Date; onReDraw: () => void }) {
  const { date, onReDraw } = props;

  const lastFetch = useRef<number>(0);

  const rectsRef = useRef<HTMLDivElement>(null);
  const mainRef = useRef<HTMLDivElement>(null);

  //
  // calculate Position from courtNumber and hour
  //
  const sizeX = common.widthCourt * 7 + 3 * common.widthHour; // common.courtSpacing[6];
  const sizeY = (common.lastHourOfDay - common.firstHourOfDay) * common.heightHour;

  useEffect(() => {
    if (rectsRef.current) {
      const inner = rectsRef.current.querySelector("#inner");
      const r = rectsRef.current?.getBoundingClientRect();

      if (r && inner && mainRef.current) {
        const b = common.widthCourt * 7 + common.widthHour * 3;
        let f1 = r.width / b;
        console.log("scale ... ", r.width, b, f1);

        if (common.anzeigeTafelMode) {
          (inner as any).style.transform = `scale(${f1})`;
          mainRef.current.style.height = `${r.height * f1 + 70}px`;
        } else {
          (inner as any).style.transform = `scale(${f1 / (window as any).mainScale})`;
          mainRef.current.style.height = `${r.height / (window as any).mainScale}px`;
          // mainRef.current.style.height = `${r.height}px`;
        }
      }
    }
  });

  const [bookings, setBookings] = useState<any>([]);

  const dayOffset = getDOY(date) - getDOY(new Date());

  function isMyBooking(booking: any) {
    for (var p in booking.partners) {
      var partner = booking.partners[p];
      if (partner.indexOf(common.user?.memberId) >= 0) {
        return true;
      }
    }

    return false;
  }

  async function fetchBookingsFromServer(d: Date) {
    const dMilliseconds = new Date().getTime() - lastFetch.current;

    if (common.anzeigeTafelMode) {
      if (dMilliseconds < 1000 * 60 * 2) {
        return;
      }
    }

    if (dMilliseconds < 1000) {
      return;
    }

    const dayOffset = (d.getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24;

    // modifiziere das Datum auf 3 uhr morgens ab gleichen tag
    // und Unterschiede in der Zeitzone das DAtum irrelevat zu machen.
    //
    // 3.3.2023  00:00 ist in UTZ 2.3.2023 22:00
    // Das führ dazu das der Server (fall er in UTC) läuft ein falsches DOY (exhtes DOY-1) liefern würde!!!
    //
    // ab 30.3.2023 versuche ich den Server hart auf 'Europe/Amsterdam' zu setzen
    // process.env.TZ = 'Europe/Amsterdam'

    const d1 = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 3, 0);

    const queryData = {
      date: d1,
      anzeigeTafelMode: common.anzeigeTafelMode,
      numdays: 1,
    };

    const multiDayBookings = await ServerInterface.getbookings(queryData);
    if (multiDayBookings) {
      const dayBookings = multiDayBookings[getDOY(d)];
      if (dayBookings) {
        setBookings(dayBookings);
        lastFetch.current = new Date().getTime();
      } else {
        console.error("error loading bookings");
      }
    }
  }

  useEffect(() => {
    fetchBookingsFromServer(props.date);
  });

  const rects: any = [];

  const numHours = common.lastHourOfDay - common.firstHourOfDay;

  //
  // create backgoundRects
  //
  for (var c = 1; c <= common.numCourts; c++) {
    for (var h = -1; h <= numHours; h++) {
      const offsetY = (common.getCourtStartTime()[c - 1] / 60) * common.heightHour;
      ///////////////////////////////////////////////////////////////////////////
      const minutes = common.getCourtStartTime()[c - 1];

      const d1 = new Date(props.date.getFullYear(), props.date.getMonth(), props.date.getDate(), h + common.firstHourOfDay, minutes);

      let disableInput = d1 < new Date() || (!common.clubhausMode && dayOffset > 2);

      const d2: Date = common.openingDate;
      if (d1 < d2) {
        disableInput = true;
      }


      // MWE Todo: 14.4.2023
      //
      // hier sollten wir ruhig 15 - 30 Minuten Luft lassen,
      // es spricht ja nicht dagegen eine schon laufende Stunde zu buchen !!!!!

      const key = `rb-${c}-${h}`;

      rects.push(<OneRect key={key} disableInput={disableInput} date={d1} numHours={1} court={c} numCourts={1} privateBooking={false} booking={undefined} onReDraw={onReDraw} />);
    }
  }

  //
  // overlay bookings
  //

  // console.log(`day ${date} ${getDOY(date)}`, bookings);
  for (var b = 0; b < bookings.length; b++) {
    const booking = bookings[b];

    const d1 = new Date(booking.date);
    var disableInput2 = d1.getTime() < new Date().getTime() && !common.clubhausMode;



    disableInput2 ||= !common.clubhausMode && dayOffset > 2;
    if (!disableInput2) {
      if (!isMyBooking(booking) && !common.clubhausMode) {
        disableInput2 = true;
      }
    }

    const key = `rf-${booking.court}-${new Date(booking.date).getHours()}`;

    rects.push(
      <OneRect
        key={key}
        disableInput={disableInput2}
        date={new Date(booking.date)}
        numHours={parseInt(booking.numHours || "1")}
        court={parseInt(booking.court)}
        numCourts={parseInt(booking.numCourts || "1")}
        privateBooking={true}
        booking={booking}
        onReDraw={onReDraw}
      />
    );
  }

  const style1 = { width: common.widthCourt };
  const header = (
    <div id="courtHeader" style={{ display: "flex", flexDirection: "row", width: "100%", transformOrigin: "left center", paddingTop: "2px", fontSize: "0.7em", color: "grey" }}>
      <div style={{ width: common.widthHour }}></div>
      <div className="headerCourtNumber" style={style1}>
        1
      </div>
      <div className="HeaderCourtNumber" style={style1}>
        2
      </div>
      <div className="HeaderCourtNumber" style={style1}>
        3
      </div>
      <div style={{ width: common.widthHour }}></div>

      <div className="HeaderCourtNumber" style={style1}>
        4
      </div>
      <div className="HeaderCourtNumber" style={style1}>
        5
      </div>
      <div className="HeaderCourtNumber" style={style1}>
        6
      </div>
      <div style={{ width: common.widthHour }}></div>
      <div className="HeaderCourtNumber" style={style1}>
        7
      </div>
    </div>
  );

  return (
    <div
      ref={mainRef}
      key={`D-getDOY(props.date)`}
      id="day"
      style={{
        position: "relative",
        width: "100%",
        height: "max-content",
        borderRadius: "10px",
        overflow: "hidden",
        border: "1px solid grey",
        marginBottom: common.anzeigeTafelMode ? "10px" : "40px",
        backgroundColor: "lightgray",
      }}
    >
      <DayHeader key="header" date={date} />

      {header}

      <div
        ref={rectsRef}
        id="rects"
        style={{
          position: "relative",
          width: "100%",
          paddingTop: "10px",
          paddingBottom: "10px",
          overflow: "hidden",
        }}
      >
        <div
          id="inner"
          style={{
            width: sizeX,
            position: "relative",
            transformOrigin: "left top",
            overflow: "hidden",
          }}
        >
          <Hours showHourBar={dayOffset <= 1} style={{}} />
          <Hours showHourBar={dayOffset <= 1} style={{ marginLeft: common.widthHour + common.widthCourt * 3 }} />
          <Hours
            showHourBar={dayOffset <= 1}
            style={{
              marginLeft: common.widthHour + common.widthCourt * 6 + common.courtSpacing[3],
            }}
          />
          <div
            id="pureRects"
            style={{
              position: "relative",
              marginLeft: common.widthHour,
              height: sizeY,
            }}
          >
            {rects}
          </div>
        </div>
      </div>
    </div>
  );
}
